<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    orderCode: String,
    type: { type: String, default: 'radio' },
  },
  data() {
    return {
    }
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      const parmas = {
        orderCode: this.orderCode,
        ...form,
      }
      this.loading = true
      this.$api.orderTechDocListApi(parmas).then((res) => {
        this.loading = false
        this.setData(res)
      })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
